import React from 'react';
import './Footer.css';

const Footer = () => (
  <div className="brand-container">
    <div className="copyright">
      © 2025 YemekTarifleri.Ai - Her hakkı saklıdır
    </div>
  </div>
);

export default Footer; 